module.exports = __webpack_public_path__ + "static/media/imagen2.45d1cf13.png";